export const Config = {
    "ENV": "Dev",
    "VERSION": "1.0.0",
    "API_URL": process.env.REACT_APP_API_BASE,
    "SSO_URL": "https://intranet-api.sutas.com.tr",
    "CDN_URL": "https://cdn.sutas.com.tr/grupsutaski"
}
